import React from 'react'
import GoogleMapReact from 'google-map-react'

const defaultProps = {
    center: {
        lat: 50.03498222656753,
        lng: 15.775544649066578,
    },
    zoom: 15,
}

const AnyReactComponent = ({ text }) => <div>{text}</div>

const GoogleMap = () => (
    <div style={{ height: '50vh', width: '100%' }}>
        <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyAg2NA8EHEGYOd56mE7x-nrQkHrpX3xoOE'}}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
        >
            <AnyReactComponent
                lat={50.03498222656753}
                lng={15.775544649066578}
                text={'Media Luna'}
            />
        </GoogleMapReact>
    </div>
)

export default GoogleMap
